import React from 'react';
import styled from 'styled-components';
import ProgressSpinner from '../ProgressSpinner';
import cn from 'classnames';
export var ProgressOverlay = function ProgressOverlay(props) {
  var className = props.className,
      active = props.active,
      label = props.label,
      children = props.children; // Do not want to apply component styles when overlay is inactive,
  // so component's styles do not interfere with the app styles

  return React.createElement("div", {
    className: cn('bbui-progress-overlay', className)
  }, active && React.createElement("div", {
    className: "dimmer"
  }, React.createElement("div", {
    className: "panel"
  }, React.createElement(ProgressSpinner, {
    size: "large",
    className: "spinner",
    label: label,
    labelPosition: "bottom"
  }))), children);
};
ProgressOverlay.defaultProps = {
  className: '',
  active: false
};
export default styled(ProgressOverlay).withConfig({
  displayName: "ProgressOverlay",
  componentId: "rikllg-0"
})(["width:100%;height:100%;min-height:200px;min-width:200px;position:relative;.dimmer{position:absolute;top:0;bottom:0;left:0;right:0;background-color:rgba(0,0,0,0.11);transition:background-color 0.25s ease-in-out;z-index:", ";display:flex;align-items:center;justify-content:center;}.panel{z-index:", ";display:flex;flex-direction:column;align-items:center;justify-content:flex-start;padding:2rem 2rem 1rem 2rem;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.depth.overlay;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.depth.dialog;
});